
import Experience from './Experience/Experience.js'

// Canvas
const canvas = document.querySelector('canvas.webgl')

const experience = new Experience(canvas)

